import { updateStyle } from '@/utils/dom'

(function (doc, win) {
  // ----start----屏幕适配rem
  const width = 1024
  const docEl = doc.documentElement
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  const recalc = function () {
    const clientWidth = docEl.clientWidth
    const list = [
      'crEnrollResult',
      'qtEnrollResult',
      'qtGardeSearch',
    ]
    const fullScreen = list.findIndex((val) => location.href.indexOf(val) >= 0) >= 0

    if (fullScreen) {
      return
    }

    // var clientWidth = screen.width
    if (!clientWidth) {
      return
    }

    if (clientWidth >= width) {
      document.getElementsByTagName('body')[0].setAttribute('style', `width:${width}px`)
      docEl.style.fontSize = '1.12500rem'
    } else {
      docEl.style.fontSize = `${16 * (clientWidth / 375).toFixed(2)}px`
    }
  }

  if (!doc.addEventListener) {
    return
  }

  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)

  // ----end------

  // ----start---IE hash改变不跳转的问题

  if (isIE) {
    // const location = window.location
    // let oldURL = location.href
    // let oldHash = location.hash
    window.addEventListener('hashchange', (e) => {
      document.location.reload()
    })
  }
})(document, window)
const isIE = /MSIE (\d+\.\d+);/.test(navigator.userAgent) || ~navigator.userAgent.indexOf('Trident/')

if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  // 移动端
} else {
  if (isIE) {
    const a = `[class*="van-hairline"]::after {
      left: auto;
      right: auto;
      top: auto;
      bottom: auto;
      content:none;
    }`
    const fieldCss = `
      .van-field__body {
        height: 100%;
      }
      .van-field__body input {
        line-height: 1px;
      }`

    const toastCss = `
      .van-toast--text {
        min-height: inherit;
        max-width: 25.00000rem;
        width: auto;
      }
      .van-toast__text {
        width: 100%;
      }`

    const dialogCss = `
    .van-dialog .van-dialog__footer .van-button{
      border:1px solid #ebedf0;
    }`

    updateStyle(fieldCss, 'my-field-input-height')
    updateStyle(toastCss, 'my-toast-fit-ie')
    updateStyle(dialogCss, 'my-dialog-fit-ie')
    updateStyle(a, 'cancel-hairline')
  }
}
